import React from 'react';
// import './LoadingOverlay.css';  // Import the overlay CSS

function LoadingOverlay({ message = "Please wait..." }) {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        {/* Bootstrap 5 spinner */}
        <div className="spinner-border text-light" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        {/* Optional text message below the spinner */}
        <div className="text-light mt-3">{message}</div>
      </div>
    </div>
  );
}

export default LoadingOverlay;